export enum GasType {
    "", "EBEM Aardgas Variabel" = 61580312, "EBEM G@s +" = 61580734, "EBEM Gas B@il" = 61580745
}